// Mock data for Prime Detail website

export const businessInfo = {
  name: "Prime Detail",
  email: "Primedetail@gmail.com",
  phone: "717-984-3476",
  hours: "8:00 AM - 8:00 PM",
  days: "Monday - Saturday",
  location: "Newmanstown, PA 17073",
  serviceRadius: "40 mile radius",
  discount: {
    eligible: "Military & First Responders",
    amount: "10%"
  }
};

export const stats = [
  { label: "Vehicles Detailed", value: "500+", icon: "car" },
  { label: "Years Experience", value: "3+", icon: "award" },
  { label: "Five Star Reviews", value: "50+", icon: "star" },
  { label: "Mobile Service", value: "100%", icon: "truck" }
];

export const services = [
  {
    id: 1,
    name: "Interior Detail",
    description: "Deep cleaning of your vehicle's interior including vacuuming, shampooing, and conditioning of all surfaces.",
    price: "$150 - $250",
    image: "https://images.unsplash.com/photo-1605437241278-c1806d14a4d9",
    features: ["Deep vacuum", "Steam cleaning", "Leather conditioning", "Odor elimination"]
  },
  {
    id: 2,
    name: "Paint Correction",
    description: "Professional multi-stage paint correction to remove swirls, scratches, and restore your paint's shine.",
    price: "$300 - $600",
    image: "https://images.pexels.com/photos/6873174/pexels-photo-6873174.jpeg",
    features: ["Swirl removal", "Scratch correction", "Paint polishing", "High-gloss finish"]
  },
  {
    id: 3,
    name: "Ceramic Coating",
    description: "Long-lasting protection with professional-grade ceramic coating for ultimate shine and durability.",
    price: "$500 - $1200",
    image: "https://images.pexels.com/photos/6872609/pexels-photo-6872609.jpeg",
    features: ["5-year protection", "Hydrophobic coating", "UV resistance", "Enhanced gloss"]
  },
  {
    id: 4,
    name: "Full Restoration",
    description: "Complete vehicle transformation including paint correction, interior revival, and protective coatings.",
    price: "$800 - $2000",
    image: "https://images.pexels.com/photos/6872580/pexels-photo-6872580.jpeg",
    features: ["Complete detailing", "Paint correction", "Interior revival", "Ceramic coating"]
  },
  {
    id: 5,
    name: "Interior Revival",
    description: "Restore your interior to like-new condition with deep cleaning, conditioning, and stain removal.",
    price: "$200 - $400",
    image: "https://images.unsplash.com/photo-1605437241278-c1806d14a4d9",
    features: ["Stain removal", "Leather restoration", "Fabric protection", "Complete sanitization"]
  },
  {
    id: 6,
    name: "Exterior Detail",
    description: "Complete exterior detailing including full wash, wheels and tires, and all glass for a pristine finish.",
    price: "$150",
    image: "https://images.unsplash.com/photo-1708805282683-50a060eba80f",
    features: ["Full exterior wash", "Wheel & tire detail", "All glass cleaning", "Exterior finish"]
  }
];

export const submitEstimateRequest = (formData) => {
  // Mock submission - will be replaced with backend API
  console.log("Estimate request submitted:", formData);
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({ success: true, message: "Thank you! We'll contact you within 24 hours." });
    }, 1000);
  });
};
